import { NavLink } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  return (
    <div className="navbar-container">
      <nav className="navbar">
        <NavLink to="/" end className="nav-item">
          Home
        </NavLink>
        <NavLink to="/projects" className="nav-item">
          Projects
        </NavLink>
        <NavLink to="/contact" className="nav-item">
          Contact
        </NavLink>
      </nav>
    </div>
  );
}
